export default __webpack_public_path__ + "static/media/regulatory--stop--g4.ee770dce.png";